import { TicketWithDetailsDto } from '@sib/api';
import { Button, Form, FormTextField } from '@sib/ui';
import { AddIcon } from '@spendbrain/icons';
import { useAppTranslation } from '@spendbrain/modules/tickets/hooks';
import { SingleLog } from '../SingleLog';
import { LogsNoItems } from './LogsNoItems';
import { TicketDetailsLogFormField, useLogsTabForm } from './LogsTabForm.utils';

interface LogsTabFormProps {
  ticket?: TicketWithDetailsDto;
}

export const LogsTabForm = ({ ticket }: LogsTabFormProps) => {
  const { t } = useAppTranslation();

  const { formProps, onSubmit } = useLogsTabForm(ticket?.id || '');
  const {
    formState: { isSubmitting, isValid },
  } = formProps;

  return (
    <Form
      className="flex flex-col gap-4 p-6"
      {...formProps}
      onSubmit={onSubmit}
    >
      <div className="flex flex-row items-end gap-2">
        <FormTextField
          label={t('components.ticketDetails.logForm.addComment')}
          name={TicketDetailsLogFormField.Log}
          placeholder={t('components.ticketDetails.logForm.placeholder')}
          readOnly={isSubmitting}
        />
        <Button
          disabled={!isValid}
          className="flex h-10 flex-row gap-2"
          type="submit"
          loading={isSubmitting}
        >
          {!isSubmitting && <AddIcon />}
          {t('components.ticketDetails.logForm.add')}
        </Button>
      </div>
      <div className="flex max-h-[280px] flex-col overflow-y-auto">
        {!ticket?.comments?.length && <LogsNoItems />}
        {!!ticket?.comments &&
          ticket?.comments.map(log => <SingleLog key={log.id} log={log} />)}
      </div>
    </Form>
  );
};
